import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { VerifyDialogData } from '@app/app.interface';
import { VerifyDialogCloseReason } from '@app/app.structs';

@Component({
  selector: 'app-verify-dialog',
  templateUrl: './verify-dialog.component.html',
  styleUrls: ['./verify-dialog.component.scss']
})
export class VerifyDialogComponent implements OnInit {
  data: VerifyDialogData;
  dialogCloseReason = VerifyDialogCloseReason;
  constructor(
    private matDialogRef: MatDialogRef<VerifyDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public dialogData : VerifyDialogData
  ) { }

  ngOnInit(): void {
    
  }

  close(closeReason: VerifyDialogCloseReason){
    this.matDialogRef.close(closeReason);
  }

}
